/**
 * Shared generic placeholder crests, served from web's `public/`.
 *
 * These paths were repeated as string literals across the app; a typo in one
 * silently renders a broken image, so they live in one place. Relative paths
 * are deliberate — they are LOCAL assets and must not go through
 * `resolveAssetUrl`, which rewrites API/S3 hosts.
 */
const BASE = '/images/generic_placeholders'

export const PLACEHOLDER_IMAGES = {
  team: `${BASE}/placeholder_team.png`,
  /** Seasons, conferences and divisions all read as "a competition". */
  competition: `${BASE}/placeholder_competition.png`,
  organization: `${BASE}/placeholder_organization.png`,
  player: `${BASE}/placeholder_player.png`,
} as const

export type PlaceholderKind = keyof typeof PLACEHOLDER_IMAGES
